import * as React from "react"
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card"
import { cn, formatCount, formatINR, formatWeight, getVariantTextColor } from "lib/utils"

export type CardVariant = "total" | "neutral" | "positive" | "negative"
export interface SummaryCardProps {
    title: string
    count: number
    cn_value: number
    actual_weight: number
    charge_weight: number
    variant?: CardVariant
    onClick?: () => void
    className?: string
    footer?: React.ReactNode
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
    title,
    count,
    cn_value,
    actual_weight,
    charge_weight,
    variant = "neutral",
    onClick,
    className,
    footer,
}) => {
    return (
        <Card
            variant={variant}
            onClick={onClick}
            className={cn(
                "overflow-hidden cursor-default select-none flex flex-col",
                onClick &&
                "cursor-pointer transition-transform hover:scale-[1.01] active:scale-[0.99]",
                className
            )}
        >
            <CardHeader className="pb-3 flex-shrink-0">
                <CardTitle className="text-lg font-semibold text-slate-800">
                    {title}
                </CardTitle>
            </CardHeader>

            <CardContent className="pt-0 flex-grow flex flex-col justify-end">
                <div className="space-y-3 mt-auto">

                    {/* Count */}
                    <div className="flex items-center justify-between">
                        <span className="text-3xl font-bold tabular-nums text-slate-900">
                            {formatCount(count)}
                        </span>
                    </div>

                    {/* CN Value */}
                    <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-600">CN Value (INR)</span>
                        <span
                            className={cn(
                                "font-semibold",
                                getVariantTextColor(variant)
                            )}
                        >
                            ₹{formatINR(cn_value)}
                        </span>
                    </div>

                    {/* Weights */}
                    <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-600">Actual Weight</span>
                        <span className="font-semibold text-slate-900">
                            {formatWeight(actual_weight)}
                        </span>
                    </div>

                    <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-600">Chargeable Weight</span>
                        <span className="font-semibold text-slate-900">
                            {formatWeight(charge_weight)}
                        </span>
                    </div>
                </div>

                {footer ? (
                    <div className="mt-2 text-xs text-slate-600/80">{footer}</div>
                ) : null}
            </CardContent>
        </Card>
    )
}
